<!--suppress XmlDuplicatedId -->
<template>
  <bs-modal
    ref="bsModal"
    name="all-done"
    :sgc="(page === 1 || (page === 3 && endAcceptedByOpponent === false)) ? '' : $t('javascript.expert_neutral_dealcloser')"
    :value="value"
    :model-value="value"
    @input="$emit('input', $event)"
  >
    <form id="sgcForm" v-if="page === 1 || (page === 3 && endAcceptedByOpponent === false)">

      <div class="form-inline">
        <div class="form-group" style="width:100%;">
          <div class="row">
            <div class="col-sm-12" style="text-align:center;">
              <label v-if="(bothAcceptanceLocked)" class="control-label" for="secret-ext">{{ $t('javascript.sorry_try_the') }}</label>
              <label v-if="!(bothAcceptanceLocked)" class="control-label" for="secret-ext">{{ $t('javascript.if_there_try_the') }}</label>
              <h3 style="margin-top:0px;">{{ $t('javascript.automatic_dealcloser') }} ?</h3>
            </div>
          </div>
          <div class="row" v-if="true !== true">
            <div class="col-sm-6" style="text-align:center;">
              <div class="input-group" v-if="(bothAcceptanceLocked)">
                <label class="control-label" for="secret-ext">{{ $t('javascript.sorry_try_the') }}</label>
              </div>
              <div class="input-group" v-if="!(bothAcceptanceLocked)">
                <label class="control-label" for="secret-ext">{{ $t('javascript.if_there_try_the') }}</label>
              </div>
              <h3 style="margin-top:0px;">{{ $t('javascript.automatic_dealcloser') }} ?</h3>
            </div>
            <div class="col-sm-6" style="text-align:center;">
              <img style="width=80%; border-radius: 15px 15px 15px 15px;" @click="showVid = true" src="/images/how_sgc_works.png">
            </div>
          </div>
          <div class="row" v-if="showVid === true">
            <div class="col-sm-12" style="text-align:center;">
              <iframe class="videoPlayer" width="100%" height="291px" src="https://www.youtube.com/embed/BcF9C8tq9AQ?si=UoL7LYkg_h1xUzvU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              <i @click="showVid = false" class="fa fa-close"></i>
            </div>
          </div>

        </div>
      </div>
      </br>

    </form>

    <form v-else-if="page === 2 && end">

      <p>
        {{ $t('javascript.do_you_want_to_use_end') }}
        <b>{{ $t('javascript.do_you_want_to_use_end2') }}</b>
        {{ $t('javascript.do_you_want_to_use_end3') }}
      </p>
    </form>

    <form v-else-if="page === 3 && end">

      <p style="color:gray;" v-if="endAcceptedByOpponent === true">
        {{ $t('javascript.the_other_party_end') }}
      </p>
      <p style="color:gray;" v-if="endAcceptedByOpponent !== true">
        {{ $t('javascript.the_other_party_not_yet_end') }}
      </p>
      <div class="row">
        <div class="col-sm-7">
          <p>
            {{ $t('javascript.be_sure_that_the_framework') }}
          </p>
        </div>
        <div class="col-sm-5" style="padding:15px 0;">
          <button v-on="isEnegotiation ? { click: cancelEnd } : {}" :class="(isEnegotiation ? 'btn btn-warning btn-nomargin' : 'btn btn-warning btn-nomargin disabled')" type="button">
            {{ $t('javascript.review_my_documents') }}
          </button>
        </div>
      </div>
      <p>
        {{$t('javascript.end_will_raise_fees_html')}}
      </p>

      <p v-if="expertNeutralCount === 1">
        {{ $t('javascript.the_end_uses_an') }}
      </p>
      <p v-if="expertNeutralCount !== 1">
        {{ $t('javascript.the_end_uses_expert', {expertNeutralCount}) }}
      </p>

      <p>
        {{$t('javascript.smartsettle_then_uses')}}
      </p>

      <span id="endconfirmlink" data-url="/images/end_fees.png" data-url2="/images/end_fees.png" data-text="Conditions Tarifaires"></span>
      <label style="margin-left: 10px;line-height:1;" for="checkbox">
        <div id="checkbox-border-div" style="display:inline-block;width:20px;border-radius:50%;">
          <input type="checkbox" id="checkbox" v-model="checked" style="margin-top:2px;margin-bottom:2px;">
        </div>
        {{ $t('javascript.i_agree_to_the_end') }} 
        <b><u>{{ $t('javascript.i_agree_that_i2') }}</u></b>
      </label>
    </form>

    <!-- For docs on the following below look at 'end_final_session_modal_flow.jpg' in this folder -->
    <template #modal-footer v-if="end">
      <template v-if="page === 1 && endAcceptedByOpponent === false || (endAcceptedByOpponent !== true && opponentEndedSession == true)"> <!-- other party has said NO to the END -->
        <!-- ROW -->
	<!-- BEGIN -->

	    <div class="row">
	      <div class="col-sm-1">
		<button @click="$emit('cancel'); $emit('input', false)" class="btn btn-default btn-nomargin pull-left" style="font-size:small;padding-left:10px;padding-right:10px;" type="button">
		  {{ $t('javascript.back') }}
		</button>
	      </div>
	      <div class="col-sm-9">
		<div class="row">
		  <div class="col-sm-7" style="text-align:right;font-size:small;">
		    {{ $t('javascript.yes_if_resulting1') }}
		    <br>
		    {{ $t('javascript.yes_if_resulting2') }}
		  </div>
		  <div id="selector" class="col-sm-5">
		    <div class="row" style="width:120%;">
		      <div class="col-sm-9">
			<select class="form-control" form="sgcForm" id="secret-ext" v-model="secretExtension">
			  <option v-for="n in gridRange" :value="n">
			    {{n}}
			  </option>
			</select>
		      </div>
		      <div class="col-sm-3">
			<span style="font-size:20px;"><i class="fa fa-question-circle" style="margin-top:10px;" :title="$t('javascript.sgc_tooltip')"></i></span>
		      </div>
		      <span style="text-align:center;">{{units}}</span>
		    </div>
		  </div>
		</div>
	      </div>
	      <div class="col-sm-2">

		<button
		  id="all-done-modal-btn"
		  ref="okBtn"
		  :style="(adcInRange ? 'font-size:small;' : 'font-size:small;padding-left:5px;padding-right:5px;')"
		  @click="okClicked(false)"
		  :class="(adcInRange ? 'btn btn-primary btn-nomargin pull-right' : 'btn btn-primary btn-nomargin pull-right')"
		  type="button"
		>
		  {{ $t('javascript.end_final') }}
		</button>

		<i class="fa fa-exclamation-circle text-warning pull-right" style="font-size:20px;margin-top:10px;" :title="$t('javascript.other_party_no_end_tooltip')"></i>
	      </div>
	    </div>


	<!-- END -->
        <!-- End ROW -->
      </template>
      <template v-else>  <!-- other party has _not_ said NO to the END -->
        <template v-if="page === 1 || (page === 3 && endAcceptedByOpponent === false)">
          <!-- ROW -->

          <template v-if="endAcceptedByOpponent === false"> <!-- other party has said NO -->
            <!-- ROW -->
            <button @click="$emit('cancel'); $emit('input', false)" class="btn btn-default pull-left btn-nomargin" type="button">
              {{ $t('javascript.cancel') }}
            </button>
            <i class="fa fa-exclamation-circle text-warning pull-right" style="font-size:20px;" :title="$t('javascript.the_other_party_no_end')"></i>
            <button
              id="all-done-modal-btn"
              ref="okBtn"
              :title="$t('javascript.the_other_party_no_end')"
              @click="okClicked(true)"
              :class="(adcInRange ? 'btn btn-primary btn-nomargin pull-right' : 'btn btn-primary btn-nomargin pull-right')"
              type="button"
            >
              {{ $t('javascript.submit_final_session') }}
            </button>
            <!-- End ROW -->
          </template>
          <template v-else> <!-- other party has _not_ said NO -->
            <!-- ROW -->
            <div class="row">
              <div class="col-sm-1">
                <button @click="$emit('cancel'); $emit('input', false)" class="btn btn-default btn-nomargin pull-left" style="font-size:small;padding-left:10px;padding-right:10px;" type="button">
                  {{ $t('javascript.back') }}
                </button>
              </div>
              <div class="col-sm-9">
                <div class="row">
                  <div class="col-sm-7" style="text-align:right;font-size:small;">
                    {{ $t('javascript.yes_if_resulting1') }}
                    <br>
                    {{ $t('javascript.yes_if_resulting2') }}
                  </div>
                  <div id="selector" class="col-sm-5">
                    <div class="row" style="width:120%;">
                      <div class="col-sm-9">
                        <select class="form-control" form="sgcForm" id="secret-ext" v-model="secretExtension">
                          <option v-for="n in gridRange" :value="n">
                            {{n}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        <span style="font-size:20px;"><i class="fa fa-question-circle" style="margin-top:10px;" :title="$t('javascript.sgc_tooltip')"></i></span>
                      </div>
                      <span style="text-align:center;">{{units}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <button
                  id="all-done-modal-btn"
                  ref="okBtn"
                  :style="(adcInRange ? 'font-size:small;' : 'font-size:small;padding-left:5px;padding-right:5px;')"
                  @click="goToNext"
                  :class="(adcInRange ? 'btn btn-primary btn-nomargin pull-right' : 'btn btn-primary btn-nomargin pull-right')"
                  type="button"
                >
                  {{ (adcInRange ? $t('javascript.skip') : $t('javascript.go')) }}
                </button>
              </div>
            </div>
            <!-- End ROW -->
          </template>


          <!-- End ROW -->
        </template>
        <template v-else-if="page === 2">
           <!-- ROW -->
          <button @click="page = 1" class="btn btn-success btn-nomargin" type="button">
            {{ $t('javascript.back') }}
          </button>
          <button @click="okClicked(false)" class="btn btn-warning btn-nomargin" type="button">
            {{ $t('javascript.no') }}
          </button>
          <button
            ref="yesBtn"
            @click="gotoPage3"
            class="btn btn-primary btn-nomargin"
            type="button"
          >
            {{ $t('javascript.yes') }}
          </button>
          <!-- End ROW -->
        </template>
        <template v-else-if="page === 3">
          <template v-if="endAcceptedByOpponent === true"> <!-- other party has said YES -->
            <p><b><u>{{ $t('javascript.assign_arbitrator') }}</u></b></p>
            <!-- ROW -->
            <button @click="page = 1" class="btn btn-success btn-nomargin" style="font-size:small;" type="button">
              {{ $t('javascript.back') }}
            </button>

            <button @click="okClicked(false)" class="btn btn-success btn-nomargin" style="font-size:small;" type="button">
              {{ $t('javascript.use_sgc_only') }}
            </button>
            <span @mouseover="handleMouseOver" @mouseleave="handleMouseOut" :title="(checked ? $t('javascript.you_are_agreeing') : $t('javascript.you_must_agree'))">
               <button
                 id="all-done-modal-btn"
                 ref="okBtn"
                 key="other_yes"
                 @click="okClicked(true)"
                 :class="(checked ? 'btn btn-primary btn-nomargin' : 'btn btn-primary btn-nomargin disabled')"
                 style="font-size:small;"
                 type="button"
               >
                 {{ $t('javascript.go_to_the_end_now') }}
               </button>
            </span>
            <!-- End ROW -->
          </template>

          <template v-else> <!-- other party has _not_ said YES -->
            <!-- ROW -->
            <button @click="page = 1" class="btn btn-success btn-nomargin" type="button">
              {{ $t('javascript.back') }}
            </button>

            <button @click="okClicked(false)" class="btn btn-success btn-nomargin" type="button">
              {{ $t('javascript.use_sgc_only') }}
            </button>

            <span :title="(checked ? $t('javascript.you_are_agreeing') : $t('javascript.you_must_agree'))">
               <button
               id="all-done-modal-btn"
               ref="okBtn"
               key="other_not_yet"
               @click="okClicked(true)"
               :class="(checked ? 'btn btn-primary btn-nomargin' : 'btn btn-primary btn-nomargin disabled')"
               type="button"
               >
                 {{ $t('javascript.go_to_the_end_now') }}
               </button>
            </span>
            <!-- End ROW -->
          </template>
        </template>
      </template>
    </template>
    <template #modal-footer v-else>  <!-- END not activated -->
      <!-- ROW -->
      <button @click="$emit('cancel'); $emit('input', false)" class="btn btn-default btn-nomargin pull-left" type="button">
        {{ $t('javascript.cancel') }}
      </button>
      <div class="input-group">
        <div id="selector">
          <select class="form-control" id="secret-ext" v-model="secretExtension">
            <option v-for="n in ((maxSgc-minSgc)/gridStepSize)" :value="(minSgc + n*gridStepSize)">
              {{minSgc + n*gridStepSize}}
            </option>
          </select>
          <br>
          <br>
          <span>Selected: {{ selected }}</span>
        </div>
      </div>

      <i class="fa fa-exclamation-circle text-warning pull-right" style="font-size:20px;margin-top:10px;" :title="$t('javascript.this_negotiation_will_end')"></i>
      <button
        id="all-done-modal-btn"
        ref="okBtn"
        @click="okClicked(false)"
        :class="(adcInRange ? 'btn btn-primary btn-nomargin pull-right' : 'btn btn-primary btn-nomargin pull-right')"
        type="button"
      >
        {{ $t('javascript.end_final') }}
      </button>
      <!-- End ROW -->
    </template>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'
  import EndConfirmModal from '../endconfirm_modal'
  import EndConfirmLink from '../../endconfirmlink'
  import { ref, computed, watch, nextTick, onMounted, onBeforeMount} from 'vue';
  export default {
    name: "all-done-modal",
    props: {
      value:                 { type: Boolean, default: false },
      end:                   { type: Boolean, default: false },
      adc:                   { type: Boolean, default: false },  // Will always be true
      adcSecretExtension:    { type: Number,  default: 0     },
      adcUnit:               { type: String,  default: 'CAD' },
      units:                 { type: String,  default: 'CAD' },
      endAcceptedByOpponent: { type: Boolean, default: null  },
      bothAcceptanceLocked:  { type: Boolean, default: null  },
      opponentEndedSession:  { type: Boolean, default: null  },
      gridStepSize:          { type: Number, default: 1 },
      yourAcceptance:        { type: Number, default: 0  },
      opponentShort:         { type: String,  default: '' },
      maxSgc:                { type: Number, default: 0  },
      minSgc:                { type: Number, default: 0  },
      expertNeutralCount:    { type: Number, default: 3 },
      isOpen:                { type: Boolean, default: false },
    },
    components: {BsModal},
    emits: ['ok', 'cancel', 'input'],
    setup(props, {emit}){
      const okBtn = ref(null)
      const yesBtn = ref(null)
      const agreeToUseAdc =  'true'
      const agreeToUseEnd = 'false'
      const showVid = false
      const checked = ref(false)
      const isOkClicked = false
      const secretExtension = ref(0)
      const page = ref(1)
      const okClicked = (arbitrationAccepted) => {
        if ((checked.value === false) && (page.value === 3) && (arbitrationAccepted != false)){
          isOkClicked = true
        } 
        else if((agreeToUseAdc === 'true') && (secretExtension.value === null) || (secretExtension.value === '')){
          // agreed but no value
        } else if ((agreeToUseAdc === 'true') && ((secretExtension.value < props.minSgc) || secretExtension.value > (props.maxSgc) )){

          // agreed and bad value
        }
        else {
          let extension = 0
          if (agreeToUseAdc === 'true')
            extension = secretExtension.value
          emit('ok', {extension, arbitrationAccepted})
          emit('input', false)  // Close modal
        }
      };
      const handleADC = () => {
        agreeToUseAdc = 'true';
      };
      const handleMouseOut = () => {
        if (checked.value == false){
	      console.log("handleMouseOut");
         const cb = document.getElementById('checkbox-border-div')
         if (cb) {
            cb.style.border = 'none'
         }
        }
      };
      const handleMouseOver = () => {
        if (checked.value == false){
	      console.log("handleMouseOver");
         const cb = document.getElementById('checkbox-border-div')
            if (cb) {
              cb.style.border = '2px solid red'
            }
        }
      };
      const goToNext = () => {
        if (agreeToUseAdc === 'false'){
          page.value = 3
        }
        if((agreeToUseAdc === 'true') && (secretExtension.value === null) || (secretExtension.value === '')){
          // agreed but no value
        } else if ((agreeToUseAdc === 'true') && ((secretExtension.value < props.minSgc) || secretExtension.value > (props.maxSgc) )){

          // agreed and bad value
        } else {
          page.value = 3
        }
      };
      const gotoPage3 = () => {
        page.value = 3
      };
      const cancelEnd = () => {
          //this.page = 2
          //$emit('cancel') 
          //$emit('input', false)
          window.location = window.location.href.replace(/\/[^\/]*$/, '/document_uploads')
      };
      watch(() => page, () => {
        if (page.value === 2) {
          nextTick().then(() => {
            // wait until yesBtn is mounted
          });
        }
      });
      watch(() => props.value, () => {
          console.log("all-done-modal value changes")
        }
      );

      watch(() => props.isOpen, () => {
        if (props.isOpen === false){
          page.value = 1
        } else {
          secretExtension.value = props.adcSecretExtension
        }
      });
      
      const unchecked = computed(() => {
        return isOkClicked && !checked.value
      }); 
      const isEnegotiation = computed(() => {
        return window.location.href.indexOf("enegotiation.org") == -1
      }); 
      const adcInRange = computed(() => {
        return (secretExtension.value === props.adcSecretExtension)
      });
      const opponentVisible = computed(() => {
        if (props.minSgc == props.yourAcceptance){
          return props.maxSgc
        } else {
          return props.minSgc
        }
      }); 
      const whichPartyisMax = computed(() => {
        if (props.minSgc == props.yourAcceptance){
          return this.$t('javascript.the_other_party', {opponentShort: props.opponentShort})
        } else {
          return this.$t('javascript.your_current_secret')
        }
      });
      const whichPartyisMin = computed(() => {
        if (props.maxSgc == props.yourAcceptance){
          return this.$t('javascript.the_other_party', {opponentShort: props.opponentShort})
        } else {
          return this.$t('javascript.your_current_secret')
        }
      }); 
      const maxAdc = computed(() => {
        return props.adcSecretExtension * 10
      }); 
      const gridRange = computed(() => {
        let t = [];
        let start = 0
        let finish = (props.maxSgc-props.minSgc)/props.gridStepSize
        for (let i = start;i<finish +1;i++){
          ((props.adcSecretExtension === props.minSgc) ? t.push(props.minSgc + i*props.gridStepSize) : t.push(props.maxSgc - i*props.gridStepSize))
        }
        return t
      });
      onBeforeMount(() => {
        //this.secretExtension = null //this.adcSecretExtension
        secretExtension.value = props.adcSecretExtension
      });
      onMounted(() => {
      });
      return {
        gridRange,
        maxAdc,
        whichPartyisMin,
        whichPartyisMax,
        opponentVisible,
        adcInRange,
        isEnegotiation,
        unchecked,
        cancelEnd,
        goToNext,
        gotoPage3,
        agreeToUseAdc,
        agreeToUseEnd,
        showVid,
        checked,
        isOkClicked,
        secretExtension,
        page,
        okClicked,
        handleADC,
        handleMouseOut,
        handleMouseOver
      }
    }
  }
</script>
